import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ValueAddFiveTypeAdapter } from './dto/value-addition-five.adapter';
import { ValueAdditionFiveType } from './value-addition-five.entity';
import { ValueAddition5TypesController } from './value-addition5-types.controller';
import { ValueAddition5TypesService } from './value-addition5-types.service';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([ValueAdditionFiveType]),
  ],
  controllers: [ValueAddition5TypesController],
  providers: [ValueAddition5TypesService, ValueAddFiveTypeAdapter, ApplicationExceptionHandler,LogsService],
  exports: [ValueAddition5TypesService]
})
export class ValueAddition5TypesModule { }
